import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventEmiterService {
  isLoadingEvent = new EventEmitter<boolean>();

  constructor() {}

  isLoadingPage(isLoading: boolean) {
    this.isLoadingEvent.emit(isLoading);
  }
}
